/*
 *  全局定义信息
 *
 *  @author caixinfeng
 *  @site https://pay.poa.ai
 *  @date 2021/5/8 07:18
 */

const errorPageRouteName = 'Error' //错误页面名称定义
const successPageRouteName = 'Success' // 支付完成页
const passGuardRouteList = [errorPageRouteName, successPageRouteName]  // 不进入路由守卫的name

/** 定义支付方式 **/
const payWay = {
    WXPAY : {wayCode: "WX_JSAPI", routeName: "CashierWxpay"},
    ALIPAYPLUS : {wayCode: "ALIPAYPLUS_JSAPI", routeName: "CashierAlipay"},
}

export default {
    errorPageRouteName: errorPageRouteName,
    successPageRouteName: successPageRouteName,
    passGuardRouteList: passGuardRouteList,
    urlTokenName: "sid", //URL传递的token名称
    tokenCacheKey: "ipayCashierSid",
    payWay: payWay,
    cacheToken: "",
    wechatAuth: "code",
    openid: "",
    wxAppId: "wx2a708dc5d25b9465",
}
